import React from 'react';
import './monthNav.css';

const MonthNav = ({ prev, next, current }) => {
    return (
        <div className="month__wrapper">
            <i className="month__nav month__nav--prev"
               onClick={ prev }
            />
            <div className="month__current">{ current }</div>
            <i className="month__nav month__nav--next"
               onClick={ next }
            />
        </div>
    );
};

export default MonthNav;